import { create } from "zustand";

export const tiposVista = [
    {
        value: 0,
        label: "Por alertas de detenidos",
    },
    {
        value: 1,
        label: "Por E/A",
    },
    {
        value: 2,
        label: "Todos los detenidos",
    }
];

const now = new Date();

const reporteTiempoStore = create((set) => ({
    /*FILTROS GENERAR REPORTE*/
    tipoVista: tiposVista[1],
    editarTipoVista: (data) => set({ tipoVista: data }),
    grupos: [],
    editarGrupos: (data) => set({ grupos: data }),
    vehiculos: [],
    editarVehiculos: (data) => set({ vehiculos: data }),
    alertas: [],
    editarAlertas: (data) => set({ alertas: data }),
    fechaInicio: new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0),
    editarFechaInicio: (data) => set({ fechaInicio: data }),
    fechaFin: new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59),
    editarFechaFin: (data) => set({ fechaFin: data }),
    /*FILTROS GENERAR REPORTE*/

    /*REPORTE*/
    listaReporte: [],
    editarListaReporte: (data) => set({ listaReporte: data }),
    vehiculoSinHorario: 0,
    listaTabla: [],
    editarListaTabla: (data) => set({ listaTabla: data }),
    editarVehiculoSinHorario: (data) => set({ vehiculoSinHorario: data }),
    /*REPORTE*/
}));

export default reporteTiempoStore;